document.addEventListener('wpcf7mailsent', (event) => {
  const newsletterFormID = 11086;
  if (newsletterFormID === event.detail.contactFormId) {
    window.location.replace(`${window.location.origin}/newsletter-agradecimento`);
  }
}, false);
